/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { io } from 'socket.io-client';
@Injectable({
  providedIn: 'root'
})
export class SocketService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  socket: any;
  url: string = '';
  constructor() {}

  initSocket(bookingId: string): void {
    if (bookingId) {
      this.url = `${environment.socket_url}?orderId=${bookingId}`;
      console.log('this.url',this.url);
      this.socket = io(this.url, {
        reconnection: true
      });

      setTimeout(() => {
        if (this.socket.connected) {
          //
        }
      }, 3000);
    }
  }

  emitAction(action: any, payload: any): void {
    this.socket.emit(action, payload);
  }

  public onEvent(event: string): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on(event, (data: any) => {
        observer.next(data);
      });
    });
  }

  disconnect() : void {
    this.socket.disconnect();
  }
}
